import { ICommonCurriculums } from '@/store/types';
import fetcher from '@/utils/fetcher';

export default async function getCurriculumns() {
  const { data } = await fetcher.get('/api/curriculums');

  return {
    data: data.data as ICommonCurriculums[],
    translation: data.translation as Record<string, Record<string, string>>,
  };
}
